import { DELETE, GET, POST, PATCH } from "../API";

const basePath = (projectId) => process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/meetings_api`;

export const getWebhookEndpointsAPICall = (projectId, onSuccess, onError) => {
    GET(`${basePath(projectId)}/webhook_endpoints`, onSuccess, onError);
};

export const createWebhookEndpointAPICall = (projectId, data, onSuccess, onError) => {
    POST(`${basePath(projectId)}/webhook_endpoints`, data, onSuccess, onError);
};

export const updateWebhookEndpointAPICall = (projectId, endpointId, data, onSuccess, onError) => {
    PATCH(`${basePath(projectId)}/webhook_endpoints/${endpointId}`, data, onSuccess, onError);
};

export const deleteWebhookEndpointAPICall = (projectId, endpointId, onSuccess, onError) => {
    DELETE(`${basePath(projectId)}/webhook_endpoints/${endpointId}`, onSuccess, onError);
};

export const rollWebhookSecretAPICall = (projectId, endpointId, onSuccess, onError) => {
    POST(`${basePath(projectId)}/webhook_endpoints/${endpointId}/roll_secret`, {}, onSuccess, onError);
};

export const sendWebhookTestAPICall = (projectId, endpointId, onSuccess, onError) => {
    POST(`${basePath(projectId)}/webhook_endpoints/${endpointId}/test`, {}, onSuccess, onError);
};

export const getWebhookDeliveriesAPICall = (projectId, endpointId, page, perPage, onSuccess, onError) => {
    GET(`${basePath(projectId)}/webhook_endpoints/${endpointId}/deliveries?page=${page}&per_page=${perPage}`, onSuccess, onError);
};

export const resendWebhookDeliveryAPICall = (projectId, deliveryId, onSuccess, onError) => {
    POST(`${basePath(projectId)}/webhook_deliveries/${deliveryId}/resend`, {}, onSuccess, onError);
};
